module.exports = __webpack_public_path__ + "static/media/MCI.956f06ab.png";